export const Annotation = () => (
  <div className="mt-3 d-flex align-items-end">
    <div className="timetable__annotation-cell bg-light border" />
    <div className="ms-1 text-xx-small">: Drop-off only</div>
  </div>
);
